import { SEGMENTS_FAMILY_NAME } from "app/components/widget/widget-utilities/segments/constants";
import { DEFAULT_DURATION_FOR_SEGMENTS, DISABLED_DURATIONS, getShouldHideSegments } from "../utils";

export const PageViewsGroup = {
    id: "SegmentsPageViewsGroup",
    properties: {
        order: "4",
        dropdownOrder: 4,
        hasWebSource: true,
        isHidden: getShouldHideSegments,
        component: "CustomSegments",
        mobileWebComponent: "MobileWebSearch",
        viewPermissions: {
            trafficSources: ["Desktop", "Total"],
        },
        title: "segments.group.analysis.tab.pageViews.title",
        group: "WebsiteAudienceOverview",
        family: SEGMENTS_FAMILY_NAME,
        dashboard: "true",
        compareOnly: "true",
        state: "digitalsuite_segments-analysis-traffic",
        apiController: "CustomSegments",
        webSource: "Desktop",
        availabilityComponent: "CustomSegments",
        periodOverPeriodSupport: true,
        defaultDuration: DEFAULT_DURATION_FOR_SEGMENTS,
        disabledDurations: DISABLED_DURATIONS,
    },
    widgets: {
        single: {
            defaultType: "SegmentsPageViewsGroupGraph",
            SegmentsPageViewsGroupGraph: {
                properties: {
                    options: {
                        showLegend: true,
                    },
                    periodOverPeriodSupport: true,
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "PageViews",
                    type: "double",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "PageViews",
                    reversed: "False",
                    yAxisMax: 1,
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
        compare: {
            defaultType: "SegmentsPageViewsGroupGraph",
            SegmentsPageViewsGroupGraph: {
                properties: {},
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    type: "double",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "PageViews",
                    reversed: "False",
                    yAxisMax: 1,
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
    },
};
